import { create } from 'zustand';

/** Open/closed state of the offline sync panel (POS-I65), shared by the banner and the POS strip. */
interface OfflineSyncPanelState {
  open: boolean;
  show: () => void;
  hide: () => void;
}

export const useOfflineSyncPanel = create<OfflineSyncPanelState>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));
